(function () {
  function initJobAccordion(root) {
    if (!root || root.dataset.jobAccordionReady === 'true') return;
    root.dataset.jobAccordionReady = 'true';

    var list = root.querySelector('[data-job-accordion-list]');
    if (!list) return;

    var collapsible = list.getAttribute('data-collapsible') !== 'false';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-job-accordion-item]'));

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-job-accordion-toggle]');
      var panel = item.querySelector('[data-job-accordion-panel]');
      if (!toggle || !panel) return;

      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        if (collapsible) {
          items.forEach(function (other) {
            if (other === item) return;
            other.classList.remove('is-open');
            var otherToggle = other.querySelector('[data-job-accordion-toggle]');
            var otherPanel = other.querySelector('[data-job-accordion-panel]');
            if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
            if (otherPanel) otherPanel.setAttribute('inert', '');
          });
        }

        if (isOpen) {
          item.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          panel.setAttribute('inert', '');
        } else {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          panel.removeAttribute('inert');
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-job-accordion]').forEach(initJobAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    section.querySelectorAll('[data-job-accordion]').forEach(initJobAccordion);
  });
})();
